export const DEFAULT_TTL_SEC = 90;

// Reply window for an offer: its own TTL + created_at (reset on every counter), else the fallback.
export function offerWindow(offer, fallbackStart, fallbackTotal = DEFAULT_TTL_SEC) {
  const ttl = Number(offer?.ttl_seconds);
  return {
    startedAt: offer?.created_at || fallbackStart,
    totalSec: ttl > 0 ? ttl : fallbackTotal,
  };
}

export function windowLive({ startedAt, totalSec }) {
  const t0 = Date.parse(startedAt);
  if (!Number.isFinite(t0)) return true;
  return Date.now() - t0 < totalSec * 1000;
}

// Tell every open Bookings / trip page to refetch right away.
export function notifyBookingUpdated(type, bookingId) {
  window.dispatchEvent(new CustomEvent("yorm:booking-updated", { detail: { type, booking_id: bookingId } }));
}
